import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './client';

export interface User {
  id: string;
  email: string;
  displayName: string;
  role: 'owner' | 'manager';
}

export interface EventSummary {
  id: string;
  slug: string;
  name: string;
  shortCode: string;
  startsOn: string;
  endsOn: string;
  publishedAt: string | null;
  archivedAt: string | null;
}

export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: () => apiFetch<{ user: User }>('/api/v1/admin/me').then((r) => r.user),
    retry: false,
  });
}

export function useLogin() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { email: string; password: string }) =>
      apiFetch<{ user: User; events: EventSummary[] }>('/api/v1/admin/login', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['me'] });
      qc.invalidateQueries({ queryKey: ['events'] });
    },
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => apiFetch<void>('/api/v1/admin/logout', { method: 'POST' }),
    onSuccess: () => qc.clear(),
  });
}
